import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Phone } from 'lucide-react';
import { COMPANY } from '@/config/site';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300 py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center">
              <img src="/logo.jpg" alt="House Plan Direct" className="h-12 w-auto" />
            </div>
            <p className="text-sm">
              Professional property floor plans and plan-measurement tools for the UK property industry.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/floor-plan-creator" className="hover:text-blue-500 transition-colors">Floor Plan Creator</Link></li>
              <li><Link to="/measurement-tool" className="hover:text-blue-500 transition-colors">Plan Measure — Measure an Existing Floor Plan</Link></li>
              <li><Link to="/floor-plan-service" className="hover:text-blue-500 transition-colors">Floor Plan Service</Link></li>
              <li><Link to="/estate-agent-floor-plans" className="hover:text-blue-500 transition-colors">Estate Agent Floor Plans</Link></li>
              <li><Link to="/landlord-floor-plans" className="hover:text-blue-500 transition-colors">Landlord Floor Plans</Link></li>
              <li><Link to="/epc-floor-plans" className="hover:text-blue-500 transition-colors">EPC Floor Plans</Link></li>
              <li><Link to="/floor-plan-from-sketch" className="hover:text-blue-500 transition-colors">Floor Plan from Sketch</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Legal &amp; Support</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/pricing" className="hover:text-blue-500 transition-colors">Pricing</Link></li>
              <li><Link to="/how-it-works" className="hover:text-blue-500 transition-colors">How It Works</Link></li>
              <li><Link to="/faqs" className="hover:text-blue-500 transition-colors">FAQs</Link></li>
              <li><Link to="/contact" className="hover:text-blue-500 transition-colors">Contact Us</Link></li>
              <li><Link to="/legal/terms" className="hover:text-blue-500 transition-colors">Terms &amp; Conditions</Link></li>
              <li><Link to="/legal/privacy" className="hover:text-blue-500 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/legal/refunds-and-cancellation" className="hover:text-blue-500 transition-colors">Refunds &amp; Cancellation</Link></li>
              <li><Link to="/legal/copyright-and-takedown" className="hover:text-blue-500 transition-colors">Copyright &amp; Takedown</Link></li>
              <li><Link to="/legal/complaints" className="hover:text-blue-500 transition-colors">Complaints</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <Mail className="h-4 w-4 mt-1 text-blue-500 flex-shrink-0" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-blue-500 transition-colors break-all">
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <Phone className="h-4 w-4 mt-1 text-blue-500 flex-shrink-0" />
                <a href={`tel:${COMPANY.telephone.replace(/\s+/g, '')}`} className="hover:text-blue-500 transition-colors">
                  {COMPANY.telephone}
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 mt-1 text-blue-500 flex-shrink-0" />
                <span>{COMPANY.tradingAddress}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Legal identity + copyright */}
        <div className="mt-8 pt-8 border-t border-gray-800 text-sm text-gray-400 space-y-2" data-testid="footer-legal-identity">
          <p>
            <strong className="text-gray-200">{COMPANY.legalName}</strong> trading as <strong className="text-gray-200">{COMPANY.tradingAs}</strong>.
            Registered in {COMPANY.registeredIn}. Company number: {COMPANY.companyNumber}.
          </p>
          <p>
            Registered office: {COMPANY.registeredOffice}. VAT status: {COMPANY.vatStatus}.
          </p>
          <p className="text-gray-500 pt-2">
            &copy; {new Date().getFullYear()} {COMPANY.tradingAs}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
